import _slicedToArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useControlledState as $69RjW$useControlledState } from "@react-stately/utils";
import { useMemo as $69RjW$useMemo } from "react";
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $ad999b7f496648d1$export$8deac67f4addf270(props) {
  var _props$selectionMode = props.selectionMode,
      selectionMode = _props$selectionMode === void 0 ? 'single' : _props$selectionMode,
      disallowEmptySelection = props.disallowEmptySelection,
      _props$isDisabled = props.isDisabled,
      isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled;

  var _ref = (0, $69RjW$useControlledState)((0, $69RjW$useMemo)(function () {
    return props.selectedKeys ? new Set(props.selectedKeys) : undefined;
  }, [props.selectedKeys]), (0, $69RjW$useMemo)(function () {
    return props.defaultSelectedKeys ? new Set(props.defaultSelectedKeys) : new Set();
  }, [props.defaultSelectedKeys]), props.onSelectionChange),
      _ref2 = _slicedToArray(_ref, 2),
      selectedKeys = _ref2[0],
      setSelectedKeys = _ref2[1];

  return {
    selectionMode: selectionMode,
    isDisabled: isDisabled,
    selectedKeys: selectedKeys,
    setSelectedKeys: setSelectedKeys,
    toggleKey: function toggleKey(key) {
      var keys;

      if (selectionMode === 'multiple') {
        keys = new Set(selectedKeys);
        if (keys.has(key) && (!disallowEmptySelection || keys.size > 1)) keys.delete(key);else keys.add(key);
      } else keys = new Set(selectedKeys.has(key) && !disallowEmptySelection ? [] : [key]);

      setSelectedKeys(keys);
    },
    setSelected: function setSelected(key, isSelected) {
      if (isSelected !== selectedKeys.has(key)) this.toggleKey(key);
    }
  };
}

export { $ad999b7f496648d1$export$8deac67f4addf270 as useToggleGroupState };